import { Component, Input, OnDestroy } from '@angular/core'
import { AuthService } from 'ng-client-auth'
import { Subject, Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { selectMenuModel } from '../../../store/selectors/selectors'
import { AppState } from '../../../store/models/app-state'
import { Store, select } from '@ngrx/store'
import { initiate_logout } from 'ng-client-auth'

export interface MenusComponentModel {
  isFacilitiesOrAgenciesMenuAvailable: boolean
  isSystemManagementMenuAvailable: boolean
  isTransactionManagementMenuAvailable: boolean
  isPatientManagmentMenuAvailable: boolean
  isUserManagementMenuAvailable: boolean
  isAdministrationMenuAvailable: boolean
  isAuthenticated: boolean
  username: string
  patientManagementUrl: string
  caseloadUrl: string
  isCaseloadAvailable: boolean
  isAllUserManagementMenuAvailable: boolean
  isUploaderToolMenuAvailable: boolean
}

const RolesToIgnore = ['Claim Processing Manager', 'Claim Processing Analyst']

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss'],
  standalone: false
})
export class MenusComponent implements OnDestroy {
  @Input() model: MenusComponentModel
  trackerUrl: string

  private componentDestroyedSubject: Subject<void>
  model$: Observable<MenusComponentModel>

  constructor(private authService: AuthService, private store: Store<AppState>) {
    this.model$ = this.store.pipe(select(selectMenuModel))
    this.componentDestroyedSubject = new Subject<void>()

    this.authService.getAppUserInfo().subscribe(user => {
      if (user?.Roles?.length) {
        if (user.Roles.some(role => RolesToIgnore.includes(role))) {
          this.trackerUrl = `${this.model.patientManagementUrl}/patientsearch`
        } else {
          this.trackerUrl = this.model.isCaseloadAvailable
            ? this.model.caseloadUrl
            : `${this.model.patientManagementUrl}/patientsearch`
        }
      }
    })
  }

  public ngOnDestroy(): void {
    this.componentDestroyedSubject.next()
    this.componentDestroyedSubject.complete()
  }

  public signOut() {
    this.store.dispatch(initiate_logout({ confirm: true }))
  }

  public signIn() {
    this.authService
      .startAuthentication()
      .pipe(takeUntil(this.componentDestroyedSubject))
      .subscribe()
  }
}
